'use client'

// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { usePersonalizedResourceFetch } from '@/lib/hooks/usePersonalizedResource';
import { myListVideos } from '@/lib/resources/my-list-videos';

function NetworkMyListVideos() {
  usePersonalizedResourceFetch(myListVideos)

  return (<></>)
}

export default NetworkMyListVideos
